import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  // Vérifier si l'utilisateur est authentifié
  if (!token) {
    // Rediriger vers la page de connexion en conservant l'URL de destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute; 